(function() {
  var lastUrl = location.href;
  var hasRun = false;
  var intervalId = null;
  
  function removeDuplicates() {
    var productItems = document.querySelectorAll('.product-grid__item[data-category-tag]');
    if (productItems.length === 0) return;
    
    var modelGroups = {};
    
    productItems.forEach(function(item) {
      var categoryTag = item.getAttribute('data-category-tag');
      if (!categoryTag || categoryTag.trim() === '') {
        categoryTag = 'no-tag-' + item.getAttribute('data-product-id');
      }
      var priceNum = parseFloat(item.getAttribute('data-product-price')) || 0;
      
      if (!modelGroups[categoryTag]) {
        modelGroups[categoryTag] = [];
      }
      modelGroups[categoryTag].push({ element: item, price: priceNum });
    });
    
    Object.keys(modelGroups).forEach(function(tag) {
      var group = modelGroups[tag];
      group.sort(function(a, b) { return a.price - b.price; });
      
      group.forEach(function(item, index) {
        if (index === 0) {
          var priceEl = item.element.querySelector('.price, [class*="price"] span');
          if (priceEl) {
            var currentText = priceEl.textContent.trim();
            if (!currentText.startsWith('Starting at:')) {
              var matches = currentText.match(/\$[\d,]+\.?\d*\s*(CAD)?/);
              if (matches) {
                priceEl.textContent = 'Starting at: ' + matches[0];
              }
            }
          }
        } else {
          item.element.remove();
        }
      });
    });
    
    hasRun = true;
    console.log('=== Filtered ===');
  }
  
  // Wait for products then run once
  function waitAndRun() {
    if (hasRun) return;
    
    var productItems = document.querySelectorAll('.product-grid__item[data-category-tag]');
    if (productItems.length > 0) {
      removeDuplicates();
    } else {
      setTimeout(waitAndRun, 200);
    }
  }
  
  // Start
  waitAndRun();
  
  // Watch for URL changes only
  intervalId = setInterval(function() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      hasRun = false;
      setTimeout(waitAndRun, 500);
    }
  }, 200);
  
})();
